<div class="modal-header justify-content-end px-3 pt-3 border-0">
  <button
    name="modalRef"
    type="button"
    class="btn-close pull-right"
    aria-label="Close"
    (click)="ModalRef.hide()"
  ></button>
</div>
<div
  class="modal-body px-5 pt-4 pb-5"
  style="max-height: 500px; overflow-y: auto"
>
  <p style="font-size: 1.7rem; color: #000" class="text-center">
    Tu foto fue subida con éxito.<br />¡Gracias por participar!
  </p>
  <p class="text-center">No olvides seguirnos en redes sociales</p>
  <div class="flex justify-content-around w-75 m-auto">
    <a
      href="https://www.facebook.com/IMPLEMENTOSREPUESTOS/"
      rel="noopener"
      target="_blank"
    >
      <img
        src="../../../../../assets/images/logos/facebook.png"
        style="width: 48px"
      />
    </a>
    <a
      href="https://www.instagram.com/implementosrepuestos/"
      rel="noopener"
      target="_blank"
    >
      <img
        src="../../../../../assets/images/logos/instagram.png"
        style="width: 48px"
      />
    </a>
    <a
      href="https://www.tiktok.com/@implementosrepuestos"
      rel="noopener"
      target="_blank"
    >
      <img
        src="../../../../../assets/images/logos/tiktok.png"
        style="width: 48px"
      />
    </a>
  </div>
</div>

<div class="modal-footer justify-content-center">
  <a [routerLink]="['/inicio']" class="btn-link" (click)="ModalRef.hide()"
    >Visita nuestra página Web</a
  >
</div>
